<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Tags</span>
      <a-button size="large" class="a-header--button slide-down-enter-active" type="primary" @click="onAdd">
        <img class="mr-2 icon-size" src="@assets/icon/plus.svg" />
        Add New Tag
      </a-button>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="5">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search Tag Name" @change="onSearch"></a-input>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="TagListColumn"
            :dataSource="filterData"
            :tableSize="tableSize">
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item @click="onViewDetails(record)"> <a-icon type="edit"></a-icon>Edit & View URLs </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)"><img class="mr-2" src="@assets/icon/delete.svg" /> Delete</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>

    <!-- Add Tag Modal -->
    <TagAdd
      :visible="isAddModalVisible"
      @close="isAddModalVisible = false"
      @created="onTagCreated"
    />
  </div>
</template>

<script>
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import TagsService from '../services/tags.service';
  import { TagListColumn } from '../columnsTable/TagListColumn';
  import TagAdd from './TagAdd.vue';

  export default {
    name: 'TagList',
    components: {
      TagAdd
    },
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        PAGE_OPTIONS,
        TagListColumn,
        data: [],
        filterData: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isLoading: true,
        isAddModalVisible: false,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      filter() {
        const searchTerm = this.filterParams.search.trim().toLowerCase();
        this.filterData = searchTerm ? this.data.filter((item) => item.name.toLowerCase().includes(searchTerm)) : this.data;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: this.filterData.length
        };
      },
      onAdd() {
        this.isAddModalVisible = true;
      },
      onTagCreated() {
        this.getList();
      },
      onDelete(record) {
        TagsService.delete(record.id).then(() => {
          this.$showSuccessMessage('Deleted Tag');
          this.getList();
        });
      },
      onViewDetails(record) {
        this.$router.push({
          path: '/tags/' + record.id
        });
      },
      onSearch(event) {
        this.filterParams.search = event.target.value;
        this.filter();
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      async getList() {
        try {
          const tagsData = await TagsService.getList((this.$store.state.user.data || {}).id);
          // Transform API data to match table column expectations
          this.data = tagsData.map((tag, index) => ({
            ...tag,
            index: index + 1,
            urlCount: tag.url_count
          }));
          this.filter();
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this tag?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          }
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style></style>
